import {asset, loadJs} from "../Libraries/Utils";
import $ from 'jquery';

let googleMapsState = 'initial';
let scheduledMaps = [];

function enableMap($map) {
    let center = {
        lat: parseFloat($map.data('latitude')),
        lng: parseFloat($map.data('longitude'))
    };
    let zoom = parseInt($map.data('zoom'), 10) || 16;
    let title = $map.data('title');

    let googleMap = new google.maps.Map($map[0], {
        zoom: zoom,
        center: center,
        disableDefaultUI: true
    });

    new google.maps.Marker({
        position: center,
        map: googleMap,
        title: title,
        icon: asset('EXT:lfmsite/Resources/Public/Icons/marker.svg'),
    });
}

window.googleMapsInit = function () {
    googleMapsState = 'loaded';
    scheduledMaps.forEach($map => enableMap($map));
};

function triggerMapLoad($map) {
    if (googleMapsState === 'initial') {
        googleMapsState = 'loading';
        scheduledMaps.push($map);

        let apiKey = $map.data('apikey');
        let url = new URL('https://maps.googleapis.com/maps/api/js');
        url.searchParams.append('callback', 'googleMapsInit');
        url.searchParams.append('loading', 'async');
        url.searchParams.append('key', apiKey);

        loadJs(url, {async: true, defer: true})
            .catch(err => console.error(err));

    } else if (googleMapsState === 'loading') {
        scheduledMaps.push($map);
    } else {
        enableMap($map);
    }
}

$('.js-map').on('click', function () {
    let mapId = '#' + $(this).data('map');
    let $map = $(mapId);
    triggerMapLoad($map);
    $(this).remove();
});

if (typeof consentApi !== 'undefined') {
    consentApi.on('enable:google-maps', ev => {
        $('.js-map').trigger('click');
    });
}
